import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";

import Controls from "./Controls";

class Item extends Component {
	getRelativeTime = sendAt => {
		return this.getTimeAgo(sendAt);
	};

	getTimeAgo = sendAt => {
		const difference = moment(sendAt).diff(moment(), "weeks");
		if (Math.abs(difference) > 4) {
			return moment(sendAt).format("D MMM, YYYY");
		} else {
			return moment(sendAt).fromNow();
		}
	};

	getText = (isSent, sendAt, isError) => {
		if (isError) {
			return "Notification failed to send";
		} else if (isSent) {
			return `Sent ${this.getRelativeTime(sendAt)}`;
		} else {
			if (!sendAt) {
				return "Draft";
			}
			if (moment(sendAt).utc() < moment().utc()) {
				return "Sending...";
			} else return `Will send ${this.getRelativeTime(sendAt)}`;
		}
	};

	renderStatus = (status, isSent, sendAt, isError) => {
		let style;
		switch (status) {
			case "SENT":
				style = "success";
				break;
			case "ERROR":
				style = "error";
				break;
			case "PENDING":
				style = "pending";
				break;
			default:
				break;
		}
		return (
			<div className={`status ${style}`}>
				<div className="caption-text">{this.getText(isSent, sendAt, isError)}</div>
			</div>
		);
	};

	renderTopic = topic => {
		const { name, id } = topic;
		return (
			<div key={id} className="react-tags__selected">
				<div className="react-tags__selected-tag">
					<span className="react-tags__selected-tag-name">{name}</span>
				</div>
			</div>
		);
	};

	render() {
		const { item, crud } = this.props;
		const { title, body, isSent, sendAt, topics, id, status } = item;
		const isError = status === "ERROR";

		return (
			<div className="item">
				<div className="pull-left content">
					{status && this.renderStatus(status, isSent, sendAt, isError)}
					<h3>{title}</h3>
					<h5>{body}</h5>
					{topics && <div className="react-tags topics">{topics.map(topic => this.renderTopic(topic))}</div>}
				</div>
				<div className="pull-right">
					<Controls canSend={!isSent && !isError} crud={crud} id={id} />
				</div>
			</div>
		);
	}
}

Item.propTypes = {
	item: PropTypes.object.isRequired,
	crud: PropTypes.object.isRequired,
};

export default Item;
